import styled from "styled-components";

export const Container = styled.div`
  header {
    width: 100%;
    background: #ffffff;
    display: flex;
    justify-content: center;
    box-shadow: 0px 3px 3px rgba(0, 0, 0, 0.1);

    div.header-logo-box-page-out {
      align-items: center;
      justify-content: center;
    }
  }
`